/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ values: NonNullable<unknown> }} Chat_Onedata_Sql_ParamsInputs */



/**
* | output |
* | --- |
* | "Values: {values}" |
*
* @param {Chat_Onedata_Sql_ParamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_sql_params = /** @type {((inputs: Chat_Onedata_Sql_ParamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Sql_ParamsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Werte: ${i?.values}`)
	return /** @type {LocalizedString} */ (`Values: ${i?.values}`)
});